var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudioLogoIcon = function SvgStudioLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.88,
    height: 22.88,
    viewBox: "0 0 22.88 22.88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.313 0A.313.313 0 0 0 0 .313v22.254c0 .173.14.313.313.313h22.254c.173 0 .313-.14.313-.313V.313A.313.313 0 0 0 22.567 0H.313ZM11.44 19.433a7.992 7.992 0 1 0 0-15.985 7.992 7.992 0 0 0 0 15.985Z",
    fill: "#000"
  })));
};
export default SvgStudioLogoIcon;